<script>
    import axios from "axios";
    import {push} from "svelte-spa-router";
    import {onMount} from "svelte";

    let email = "";
    let password = "";

    $: loginFailed = false;
    $: errorMessage = "";

    // check for token and redirect to admin page if logged in
    onMount(() => {
        if (window.localStorage.getItem("token") !== null) {
            axios
                .get("/api/admin/user", {
                    headers: {
                        Authorization:
                            "Bearer " + window.localStorage.getItem("token"),
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        push("/admin");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    });

    function submit() {
        axios
            .post(
                "/api/login",
                {
                    email: email,
                    password: password,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then(function (response) {
                console.log(response);

                if (response.status === 200) {
                    // store token in local storage and redirect to admin page
                    console.log("login response", response.data)
                    window.localStorage.setItem("token", response.data.token);
                    window.localStorage.setItem("userId", response.data.userId);
                    push("/admin");
                }
            })
            .catch(function (error) {
                console.log(error);
                loginFailed = true;
                errorMessage = error.message;

                if (error.response.status === 401) {
                    errorMessage = "Email oder Passwort falsch";
                } else if (error.response.status === 500) {
                    errorMessage =
                        "Serverfehler, bitte melden Sie sich beim Wartungsteam";
                }
            });
    }

    async function resetPassword() {
        await axios
            .post("/api/admin/user/passwordreset?email=" + email)
            .then(function (response) {
                console.log(response);

                if (response.status === 200) {
                    document.getElementById("resetModal").style.display =
                        "none";
                }
            })
            .catch(function (error) {
                console.log(error);
                loginFailed = true;
                errorMessage = error.message;

                if (error.response.status === 500) {
                    errorMessage =
                        "Serverfehler, bitte melden Sie sich beim Wartungsteam";
                }
            });
    }

    function onShowResetModal() {
        document.getElementById("resetModal").style.display = "block";
    }

    function onCloseResetModal() {
        document.getElementById("resetModal").style.display = "none";
    }
</script>

<form class="form-container">
    <div class="form">
        <div class="headline-l headline">Login</div>

        <div class="input-fields">
            <label for="email" class="text-l">Email</label>
            <input type="email" name="email" id="email" bind:value={email}/>

            <label for="password" class="text-l">Password</label>
            <input
                    type="password"
                    name="password"
                    id="password"
                    bind:value={password}
            />
        </div>

        <div on:click={onShowResetModal}>Passwort vergessen?</div>

        {#if loginFailed}
            <div class="error-message">{errorMessage}</div>
        {/if}

        <button type="button" on:click={submit} class="button text-l"
        >Login
        </button
        >
    </div>
</form>

<div id="resetModal" class="modal">
    <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: center;"
    >
        <div class="modal-content">
            <img
                    src="/images/icons/close.svg"
                    alt="Schließen"
                    on:click={onCloseResetModal}
                    class="modal-close-button"
            />
            <div class="headline-xs">Passwort zurücksetzen</div>
            <div class="text-l">Bitte geben Sie Ihre Email-Adresse ein</div>
            <input type="email" name="email" id="emailreset" bind:value={email}/>
            <button type="button" on:click={resetPassword} class="button text-l">
                Passwort zurücksetzen
            </button>
        </div>
    </div>
</div>

<style>
    #resetModal {
        display: none;
    }

    .form-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .form {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        /* width: 100%; */
        max-width: 400px;
    }

    .input-fields {
        padding: 16px 16px;
    }

    .headline {
        padding: 16px 16px;
    }

    .button {
        margin: 16px 16px;
    }

    input {
        margin-top: 4px;
    }

    .error-message {
        color: red;
        margin: 16px 16px;
    }

    .modal {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        padding-top: 33%;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        overflow: auto;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .modal-content {
        position: relative;
        display: grid;
        width: auto;
        max-width: 512px;
        height: auto;
        background-color: var(--white-100);
        border-radius: 8px;
        border: 1px solid var(--black-100);
        padding: 64px;
        align-self: flex-end;
    }

    .modal-close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 24px;
        height: 24px;
        cursor: pointer;
    }
</style>
